import { useMemo } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import 'keen-slider/keen-slider.min.css';
import { ChevronRightIcon } from '@/icons';
import { useFetchFeaturedQuizzesSummary } from '@/module/featured/hook/useFetchFeaturedQuizzesSummary';
import { useMoveFeaturedPage } from '@/module/featured/hook/useMoveFeaturedPage';
import { RollingBanner } from '@/module/featured/shared/RollingBanner/RollingBanner';
import { getSafeSchoolNameTKey } from '@/shared/category/getSafeSchoolNameTKey';
import { IconButton } from '@/ui_v3';
import { cn } from '@/utils/tailwind.util';
import { type RollBannerItem, RollingBannerItem } from '../RollingBanner/RollingBannerItem';
export const FeaturedQuizRollingBanner = ({
  className,
  schoolType
}: {
  className?: string;
  schoolType: string;
}) => {
  const router = useRouter();
  const {
    t
  } = useTranslation(['common']);
  const {
    data,
    isFetching
  } = useFetchFeaturedQuizzesSummary({
    schoolType
  });
  const moveFeaturedPage = useMoveFeaturedPage(schoolType, 'DAILY');
  const schoolName = getSafeSchoolNameTKey(schoolType);
  const initBanner: RollBannerItem = useMemo(() => ({
    thumbnailImage: '',
    title: <>
          <span className={'text-strong'}>{t(schoolName)}</span>
          &nbsp;
          {t('common:category.popular')}
        </>,
    leftSlot: '🔥'
  }), [schoolName, t]);
  const menuData = useMemo(() => {
    if (!data?.data) return [];
    const _data: RollBannerItem[] = data?.data.daily.map(d => ({
      thumbnailImage: d.thumbnailImage ?? '',
      title: d.title,
      leftSlot: d.order,
      contentClick: () => router.push(`/quiz/${d.quizsetId}`)
    }));
    return [initBanner, ..._data];
  }, [data?.data, initBanner, router]);
  return <div className={cn('flex h-[48px] w-full items-center justify-between gap-2xs self-stretch rounded-[12px] border-opacity-assistive bg-neutral pl-lg pr-sm ', className)} data-sentry-component="FeaturedQuizRollingBanner" data-sentry-source-file="FeaturedQuizRollingBanner.tsx">
      {isFetching || menuData.length === 0 ? <RollingBannerItem {...initBanner} /> : <RollingBanner menus={menuData} useLoop={menuData.length > 1} />}
      <IconButton variant="transparent" intent="neutral" size="xs" onClick={() => moveFeaturedPage()} data-sentry-element="IconButton" data-sentry-source-file="FeaturedQuizRollingBanner.tsx">
        <ChevronRightIcon size="xs" data-sentry-element="ChevronRightIcon" data-sentry-source-file="FeaturedQuizRollingBanner.tsx" />
      </IconButton>
    </div>;
};